module.exports = __webpack_public_path__ + "static/media/contest-icon.709c9272.png";